import { DATA_STATE_COMPLETED, DATA_STATE_CURRENT, DATA_STATE_SELECTED, } from '../../../../constants';
import { getFontFamily as getGlobalFontFamily } from './global';
export function getFontFamily(transformer, config) {
    // The NN fonts Dagny and Nitti Grotesk do not contain Greek characters.
    // In NN Greece Calibri is used with a fall-back to Arial for non-Windows.
    if (config.getLocale() === 'el-GR') {
        return getFontFamilyCalibri(transformer);
    }
    if (config.getFeatureFlags().newFont.isEnabled()) {
        return getFontFamilyNittiGrotesk(transformer);
    }
    return getFontFamilyDagny(transformer);
}
function getFontFamilyNittiGrotesk(transformer) {
    const globalFontFamily = getGlobalFontFamily(transformer);
    return Object.freeze({
        heading: { value: globalFontFamily.nittiGroteskHeading },
        currency: {
            s: {
                default: { value: globalFontFamily.nittiGroteskTextRegular },
                attentional: { value: globalFontFamily.nittiGroteskTextBold },
            },
            m: { value: globalFontFamily.nittiGroteskTextBold },
            l: { value: globalFontFamily.nittiGroteskTextBold },
        },
        button: { value: globalFontFamily.nittiGroteskTextMedium },
        term: { value: globalFontFamily.nittiGroteskTextBold },
        body: { value: globalFontFamily.nittiGroteskTextRegular },
        form: {
            label: { value: globalFontFamily.nittiGroteskTextMedium },
            characterInput: { value: globalFontFamily.nittiGroteskTextMedium },
            datepicker: {
                date: {
                    dataStates: {
                        [DATA_STATE_SELECTED]: {
                            value: globalFontFamily.nittiGroteskTextBold,
                        },
                    },
                },
            },
        },
        listItem: {
            term: { value: globalFontFamily.nittiGroteskTextBold },
            attentional: { value: globalFontFamily.nittiGroteskTextBold },
            description: {
                l: { value: globalFontFamily.nittiGroteskTextBold },
                xl: { value: globalFontFamily.nittiGroteskTextBold },
            },
        },
        strongImportance: { value: globalFontFamily.nittiGroteskTextBold },
        link: {
            strong: { value: globalFontFamily.nittiGroteskTextBold },
        },
        stepIndicator: {
            label: {
                default: { value: globalFontFamily.nittiGroteskTextRegular },
                dataStates: {
                    [DATA_STATE_CURRENT]: { value: globalFontFamily.nittiGroteskTextBold },
                    [DATA_STATE_COMPLETED]: {
                        value: globalFontFamily.nittiGroteskTextRegular,
                    },
                },
            },
        },
        tab: { value: globalFontFamily.nittiGroteskTextMedium },
    });
}
function getFontFamilyCalibri(transformer) {
    const globalFontFamily = getGlobalFontFamily(transformer);
    return Object.freeze({
        heading: { value: globalFontFamily.calibri },
        currency: {
            s: {
                default: { value: globalFontFamily.calibri },
                attentional: { value: globalFontFamily.calibri },
            },
            m: { value: globalFontFamily.calibri },
            l: { value: globalFontFamily.calibri },
        },
        button: { value: globalFontFamily.calibri },
        term: { value: globalFontFamily.calibri },
        body: { value: globalFontFamily.calibri },
        form: {
            label: { value: globalFontFamily.calibri },
            characterInput: { value: globalFontFamily.calibri },
            datepicker: {
                date: {
                    dataStates: {
                        [DATA_STATE_SELECTED]: { value: globalFontFamily.calibri },
                    },
                },
            },
        },
        listItem: {
            term: { value: globalFontFamily.calibri },
            attentional: { value: globalFontFamily.calibri },
            description: {
                l: { value: globalFontFamily.calibri },
                xl: { value: globalFontFamily.calibri },
            },
        },
        strongImportance: { value: globalFontFamily.calibri },
        link: {
            strong: { value: globalFontFamily.calibri },
        },
        stepIndicator: {
            label: {
                default: { value: globalFontFamily.calibri },
                dataStates: {
                    [DATA_STATE_CURRENT]: { value: globalFontFamily.calibri },
                    [DATA_STATE_COMPLETED]: { value: globalFontFamily.calibri },
                },
            },
        },
        tab: { value: globalFontFamily.calibri },
    });
}
function getFontFamilyDagny(transformer) {
    const globalFontFamily = getGlobalFontFamily(transformer);
    return Object.freeze({
        heading: { value: globalFontFamily.dagnyDisplay },
        currency: {
            s: {
                default: { value: globalFontFamily.dagnyText },
                attentional: { value: globalFontFamily.dagnyDisplay },
            },
            m: { value: globalFontFamily.dagnyDisplay },
            l: { value: globalFontFamily.dagnyDisplay },
        },
        button: { value: globalFontFamily.dagnyDisplay },
        term: { value: globalFontFamily.dagnyDisplay },
        body: { value: globalFontFamily.dagnyText },
        form: {
            label: { value: globalFontFamily.dagnyDisplay },
            characterInput: { value: globalFontFamily.dagnyDisplay },
            datepicker: {
                date: {
                    dataStates: {
                        [DATA_STATE_SELECTED]: { value: globalFontFamily.dagnyDisplay },
                    },
                },
            },
        },
        listItem: {
            term: { value: globalFontFamily.dagnyDisplay },
            attentional: { value: globalFontFamily.dagnyDisplay },
            description: {
                l: { value: globalFontFamily.dagnyDisplay },
                xl: { value: globalFontFamily.dagnyDisplay },
            },
        },
        strongImportance: { value: globalFontFamily.dagnyDisplay },
        link: {
            strong: { value: globalFontFamily.dagnyDisplay },
        },
        stepIndicator: {
            label: {
                default: { value: globalFontFamily.dagnyText },
                dataStates: {
                    [DATA_STATE_CURRENT]: { value: globalFontFamily.dagnyDisplay },
                    [DATA_STATE_COMPLETED]: { value: globalFontFamily.dagnyText },
                },
            },
        },
        tab: { value: globalFontFamily.dagnyDisplay },
    });
}
